import Application from '../../Application'
import {
  ICollectionMetadata,
  ISchema,
  ISchemaPayload,
} from '../client/PGManager'
import Collection from './Collection'

export default class Schema {
  private _info?: ISchema
  // private _collections?: ICollectionMetadata[]

  constructor(
    public readonly app: Application,
    public readonly db: string,
    public readonly ref: string,
    info?: ISchema
  ) {
    if (info) {
      this._info = info
    }
  }

  // getters
  get info(): ISchema | void {
    return this._info
  }

  get collections(): ICollectionMetadata[] | void {
    return this._info && this._info.collections
  }

  // factories
  collection(collection: string): Collection {
    return new Collection(this.app, this.db, this.ref, collection)
  }

  // api
  drop(): Promise<this> {
    return this.app
      .client()
      .pgManager.dropSchema(this.db, this.ref)
      .then(() => {
        this._info = undefined

        return this
      })
  }

  create(options: ISchemaPayload): Promise<this> {
    return this.app
      .client()
      .pgManager.createSchema({
        ...options,
        db: this.db,
        name: this.ref,
      })
      .then((info) => {
        this._info = info

        return this
      })
  }

  sync(): Promise<this> {
    return this.app
      .client()
      .pgManager.getSchema(this.db, this.ref)
      .then((info) => {
        this._info = info

        return this
      })
  }
}
